import { Module, VuexModule, Mutation } from "vuex-module-decorators";

@Module({
  namespaced: true,
  name: "OrgManagement"
})
export default class OrgManagement extends VuexModule {
  searchQuery = "";
  organizationSearchQuery = "";
  propertySearchQuery = "";
  stationSearchQuery = "";

  @Mutation
  updateSearchQuery(val: OrgManagement["searchQuery"]) {
    this.searchQuery = val;
  }

  @Mutation
  updateOrganizationSearchQuery(val: OrgManagement["organizationSearchQuery"]) {
    this.organizationSearchQuery = val;
  }

  @Mutation
  updatePropertySearchQuery(val: OrgManagement["propertySearchQuery"]) {
    this.propertySearchQuery = val;
  }

  @Mutation
  updateStationSearchQuery(val: OrgManagement["stationSearchQuery"]) {
    this.stationSearchQuery = val;
  }
}
